export const colors = {
  background: '#0D131A',
  surface: '#2c3153',
  onSurface: '#1D2833',
  onSurface100: '#17212B',
  onSurface200: '#2b3947',
  onSurface400: '#9fafb9',
  onSurface500: '#d1dee6',
  onSurface600: '#f9f9f9',
  muted: '#7A8A99',
  muted40: 'rgba(182, 185, 255, 0.4)',
  muted10: 'rgba(182, 185, 255, 0.1)',
  text: '#ffffff',
  gray: '#7e7e88',
  primary: '#00d395',
  secondary: '#8b75d7',
  success: '#1dd9ba',
  success200: '#e8fcee',
  successGraph: '#33a386',
  error: '#ff6d6d',
  error200: '#f8e7ec',
  errorGraph: '#b44451',
  warning: '#ff832b',
  warning200: '#fcede8',
  warningGraph: '#c57a3a',
  notice: '#e0f1f9',
  link: '#00AD79',
  linkHover: '#00C289',
  tableRowHover: '#17212B',
  tableStickyBg: '#1D2833',
  bgGradientStart: '#2a197d',
  bgGradientMiddle: '#4331e9',
  bgGradientEnd: '#6a6cfb',
  transparent: 'transparent',
  border: 'rgba(255, 255, 255, 0.4)',
  border15: 'rgba(255, 255, 255, 0.15)',
  btnGradientDark: '#29265e',
  btnGradientLight: '#35337c',
  btnGradientDarkHover: '#26225b',
  btnGradientLightHover: '#3a2f77',
  neutral: 'rgba(255, 255, 255, 0.15)',
  tooltip: '#1c1828',
  white: 'rgba(255, 255, 255)',
  white25: 'rgba(255, 255, 255, 0.25)',
  white40: 'rgba(255, 255, 255, 0.4)',
  white70: 'rgba(255, 255, 255, 0.7)',
  white85: 'rgba(255, 255, 255, 0.85)',
  black23: 'rgba(0, 0, 0, 0.23)',
  black65: 'rgba(0, 0, 0, 0.65)',
  chartLine: '#19D3B4',
  chartIndicatorLine: '#14D5F3',
  chartUp: '#45C8E5',
  chartDown: '#A979D8',
  skeleton: {
    baseColor: 'rgba(62, 90, 123, 0.1)',
    highlightColor: 'rgba(122, 138, 153, 0.2)'
  }
};
